import React from 'react';

// Binary status: green when the budget is met, red otherwise
export const getStatusColors = (ratio) => {
    if (ratio >= 1) return { color: '#1b6e2d', backgroundColor: '#e3f4e7' };
    return { color: '#b3261e', backgroundColor: '#fde7e5' };
};

const StatusPill = ({ ratio, children }) => (
    <span
        style={{
            display: 'inline-block',
            minWidth: '3.5rem',
            padding: '0.1rem 0.6rem',
            borderRadius: '1rem',
            fontWeight: 600,
            textAlign: 'center',
            ...getStatusColors(ratio),
        }}
    >
        {children}
    </span>
);

export default StatusPill;
